// AlertContext.js
import React from "react";
import { createContext, useState, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { NotificationGroup } from '@progress/kendo-react-notification';
import { Alert } from '../components/base/alert/Alert.jsx';

export const AlertContext = createContext();

export function AlertProvider({ children }) {
    const [toasts, setToasts] = useState([]);

    const remove = useCallback(id => {
        setToasts(prev => prev.filter(t => t.id !== id));
    }, []);

    const push = useCallback((type, message) => {
        const id = Date.now();
        setToasts(prev => [...prev, { id, type, message }]);

        const timeout = setTimeout(() => remove(id), 8000);
        // clean up if toast removed manually
        return () => clearTimeout(timeout);
    }, [remove]);

    return (
        <AlertContext.Provider value={{ push, remove }}>
            {children}
            {createPortal(
                <NotificationGroup style={{ position:'fixed', right:20, bottom:20 }}>
                    {toasts.map(({ id, type, message }) => (
                        <Alert
                            key={id}
                            type={type}
                            message={message}
                            onClose={() => { remove(id); }}
                        />
                    ))}
                </NotificationGroup>,
                document.body
            )}
        </AlertContext.Provider>
    );
}

